export type DashboardTaskAssigneeCondition = 'and' | 'or'

export interface ReqDashboardTaskSearchQuery {
  assigneeCondition?: DashboardTaskAssigneeCondition
  assignees?: number[]
  keyword?: string
  completeStatus?: boolean
}

export type ResDashboardTaskSearchQuery = {
  count: number
  result: DashboardTaskItem[]
  taskType: 'RFE' | 'Interview' | 'Biometric' | 'Case Inquiry Eligible' | 'AOS Eligible'
}[]

export interface DashboardTaskItem {
  applicantName: string
  applicantPathId: number
  assigneeIds: number[]
  assigneeNames: string[]
  caseNumber: string
  caseType: string
  completeUserId: number
  completeUserName: string
  completedDate: string
  isComplete: boolean
  pendingDays: number
  taskId: number
}

export type FilterCondition = 'and' | 'or'
export const FilterCondition = {
  and: 'and',
  or: 'or',
} as const
